import {Loader2} from "lucide-react";
import {useState} from "react";

import {Button} from "@/components/ui/button";
import FormError from "@/components/ui/form-error";
import {Input} from "@/components/ui/input";
import {Label} from "@/components/ui/label";
import {cn} from "@/lib/utils";

type ClaimCodeStepProps = {
  onSubmit: (code: string) => void;
  isPending: boolean;
  errorMessage?: string;
  fieldError?: string;
  initialCode?: string;
};

export default function ClaimCodeStep({
  onSubmit,
  isPending,
  errorMessage,
  fieldError,
  initialCode = "",
}: ClaimCodeStepProps) {
  const [code, setCode] = useState(initialCode);

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    onSubmit(code.trim());
  };

  return (
    <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
      <p className="text-sm text-muted-foreground">
        Enter the claim code from your welcome letter or email.
      </p>

      <div className="flex flex-col gap-2">
        <Label htmlFor="claim_code">Claim code</Label>
        <Input
          id="claim_code"
          value={code}
          onChange={(event) => setCode(event.target.value)}
          placeholder="Enter your claim code"
          disabled={isPending}
          autoComplete="off"
        />
        {fieldError ? <FormError error={fieldError} /> : null}
      </div>

      {errorMessage ? <FormError error={errorMessage} /> : null}

      <Button
        type="submit"
        className={cn("w-full", isPending && "cursor-not-allowed opacity-80")}
        disabled={isPending || !code.trim()}
      >
        {isPending ? (
          <>
            Continuing...
            <Loader2 className="ml-2 size-4 animate-spin" />
          </>
        ) : (
          "Continue"
        )}
      </Button>
    </form>
  );
}
